import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Wrapper, Grid, H, Image, P } from '@farewill/ui'
import { screenMax, screenMin } from '@farewill/ui/helpers/responsive'
import { BREAKPOINT } from '@farewill/ui/tokens'

import PreventOrphan from 'components/PreventOrphan'
import BreakpointSwitch from 'components/BreakpointSwitch'

const StyledGrid = styled(Grid)`
  align-items: center;

  ${screenMax.s`
    grid-gap: 0;
  `}
`

const StyledWrapperImage = styled(Wrapper)`
  margin: 0 auto;
  max-width: 245px;

  ${screenMin.s`
    max-width: 400px;
  `}
`

const StyledImage = styled(Image)`
  width: 100%;
  object-fit: contain;
`

const ExplainerLayout = ({
  additionalContent,
  title,
  description,
  imagePath,
  imageCentered,
  imageCenteredFromM,
  imageWidth,
  imageComponent,
  titleDecorative,
  imagePosition,
}) => (
  <StyledGrid container marginFromL={[0, 'auto']}>
    <Grid.Item
      startColumnFromL={imagePosition === 'left' ? 7 : 1}
      spanFromL={6}
      startColumnFromM={imagePosition === 'left' ? 6 : 1}
      spanFromM={7}
      startRow={imagePosition === 'left' ? 2 : 1}
      startRowFromM={1}
      noTrim
    >
      {title && (
        <H size="L" tag="h2" maxWidth={575} decorative={titleDecorative}>
          <BreakpointSwitch
            aboveComponent={<PreventOrphan>{title}</PreventOrphan>}
            belowComponent={title}
            breakAt={BREAKPOINT.M}
          />
        </H>
      )}
      {description && (
        <P size="L" maxWidth={575} margin={[0, 0, 'L', 0]}>
          {description}
        </P>
      )}
      {additionalContent && (
        <Wrapper margin={['L', 0]}>{additionalContent}</Wrapper>
      )}
    </Grid.Item>
    <Grid.Item
      startColumnFromL={imagePosition === 'left' ? 1 : 7}
      startColumnFromM={imagePosition === 'left' ? 1 : 8}
      spanFromL={6}
      spanFromM={5}
      startRow={imagePosition === 'left' ? 1 : 2}
      startRowFromM={1}
      centered={imageCentered}
      centeredFromM={imageCenteredFromM}
      noTrim
    >
      {imageComponent || (
        <StyledWrapperImage>
          <StyledImage path={imagePath} width={imageWidth} widthFromL={400} />
        </StyledWrapperImage>
      )}
    </Grid.Item>
  </StyledGrid>
)

ExplainerLayout.defaultProps = {
  additionalContent: null,
  imageCentered: false,
  imageCenteredFromM: true,
  imageWidth: 245,
  imageComponent: null,
  titleDecorative: true,
  imagePosition: 'right',
}

ExplainerLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  imagePath: PropTypes.string.isRequired,
  additionalContent: PropTypes.node,
  imageCentered: PropTypes.bool,
  imageCenteredFromM: PropTypes.bool,
  imageWidth: PropTypes.number,
  imageComponent: PropTypes.node,
  titleDecorative: PropTypes.bool,
  imagePosition: PropTypes.oneOf(['left', 'right']),
}

export default ExplainerLayout
